import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class ProyeccionStock {
  saveProyeccionExportador (values) {
    const axios = getAxiosInstance()
    const promise = axios.post(`cupo_proyectado`, { valores: { ...values } })
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result)
  }

  getProyeccionExportador () {
    const axios = getAxiosInstance()
    const orden = '{"orden":["fecha", "cereal"]}'
    const promise = axios.get(`consulta_cupo_proyectado?r=${orden}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result.data)
  }

  deleteProyeccion (fecha, cereal, exportador) {
    const axios = getAxiosInstance()
    const filtro = `{"clave" : { "fecha": "${fecha}", "cereal": "${cereal}", "exportador": "${exportador}"}}`
    const promise = axios.delete(`cupo_proyectado?r=${filtro}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => result)
  }
}

export default ProyeccionStock
